// extracted by mini-css-extract-plugin
module.exports = {"cmp":"layout_cmp__15KBb","banner":"layout_banner__3LSKP","dismiss":"layout_dismiss__2NVBt","off":"layout_off__3unre"};